import { tableHeaderRowClasses } from '../../../../components/common/dashboardTableClasses';

const spinnerClasses = "animate-spin h-8 w-8 border-[0.25em] border-primary border-t-transparent rounded-full inline-block";

const headerRowClasses = `sticky top-0 ${tableHeaderRowClasses}`;

const ReportTable = ({ columns, rows, isLoading, tableClassName = "" }) => {
  return (
    <>
      <div className="max-h-75 overflow-auto">
        <table className={`upcoming-table w-full ${tableClassName}`}>
          <thead>
            <tr className={headerRowClasses}>
              {columns.map((col, index) => (
                <th
                  key={index}
                  className="px-2 py-2 text-left text-base font-bold text-label"
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={columns.length} className="px-2 py-3 text-center">
                  <div className={spinnerClasses} role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : rows && rows.length > 0 ? (
              rows.map((row, rowIndex) => (
                <tr key={rowIndex} className="border-b">
                  {columns.map((col, colIndex) => (
                    <td key={colIndex} className="px-2 py-2">
                      {col.render ? col.render(row) : row[col.accessor]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="px-2 py-3 text-center text-subtle">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ReportTable;